var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cdiv class=\"md-padding\" ng-if=\"!vm.loading\"\u003E\u003Cdiv ng-switch=\"vm.reportType\"\u003E\u003Cdiv ng-switch-when=\"sample\"\u003E\u003Ch2\u003EDun & Bradstreet risk score (FUNDED INVESTORS ONLY)\u003C\u002Fh2\u003E\u003Chelp-box\u003E\u003Cp\u003EFunded investors will be provided with charts derived from information provided by\n\u003Ca href=\"http:\u002F\u002Fdnb.com.au\"\u003EDun & Bradstreet\u003C\u002Fa\u003E. \u003C\u002Fp\u003E\u003Cp\u003EThe following information is \u003Cb\u003ESAMPLE DATA ONLY\u003C\u002Fb\u003E and in\nno way relates to any existing business or loan.\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Cdiv layout-padding\u003E\u003Cchartist class=\"ct-chart sample ct-minor-seventh\" if-media-size=\"gt-xs\" chartist-data=\"vm.drsChartData\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.drsChartOptions\" chartist-events=\"vm.drsChartEvents\"\u003E\u003C\u002Fchartist\u003E\u003Cchartist class=\"ct-chart sample ct-minor-seventh\" if-media-size=\"xs\" chartist-data=\"vm.drsSmallChartData\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.drsChartOptions\" chartist-events=\"vm.drsChartEvents\"\u003E\u003C\u002Fchartist\u003E\u003Cp\u003EFor more information on the Dun & Bradstreet Failure Risk Score, see \u003Ccontentful-asset title=\"drs fact sheet\"\u003Ehere\u003C\u002Fcontentful-asset\u003E.\u003C\u002Fp\u003E\u003Cp\u003EFor more information on the Dun & Bradstreet Small Business Risk Score, see \u003Ccontentful-asset title=\"sbrs fact sheet\"\u003Ehere\u003C\u002Fcontentful-asset\u003E.\n\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-switch-when=\"drs\"\u003E\u003Chelp-box ng-if=\"vm.loanRequest.status === 'fulfilled'\" heading=\"Dun &amp; Bradstreet risk score\"\u003E\u003Cp\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E Warning: the information on this page was current at {{ vm.loanRequest.auction.endDate | date }}. \nBorrowers' circumstances may vary over the period of a loan.\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Ch2 ng-if=\"vm.loanRequest.status != 'fulfilled'\"\u003EDun & Bradstreet risk score\u003C\u002Fh2\u003E\u003Cdiv layout-padding\u003E\u003Cchartist class=\"ct-chart ct-minor-seventh\" if-media-size=\"gt-xs\" chartist-data=\"vm.drsChartData\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.drsChartOptions\" chartist-events=\"vm.drsChartEvents\"\u003E\u003C\u002Fchartist\u003E\u003Cchartist class=\"ct-chart ct-minor-seventh\" if-media-size=\"xs\" chartist-data=\"vm.drsSmallChartData\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.drsChartOptions\" chartist-events=\"vm.drsChartEvents\"\u003E\u003C\u002Fchartist\u003E\u003Cp\u003EThese descriptions are derived from the Failure Risk Score (DRS) as calculated by\n\u003Ca href=\"http:\u002F\u002Fdnb.com.au\"\u003EDun & Bradstreet\u003C\u002Fa\u003E, a third-party Data Services company.\nThe Failure Risk Score is one of many factors considered by \u003Ctenant-inline element-id=\"name.short\"\u003E\u003C\u002Ftenant-inline\u003E in its overall\nassessment of a potential borrower.\u003C\u002Fp\u003E\u003Cp\u003EFor more information on the Dun & Bradstreet Failure Risk Score, see \u003Ccontentful-asset title=\"drs fact sheet\"\u003Ehere\u003C\u002Fcontentful-asset\u003E.\n\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-switch-when=\"sbrs\"\u003E\u003Chelp-box ng-if=\"vm.loanRequest.status === 'fulfilled'\" heading=\"Dun &amp; Bradstreet risk score\"\u003E\u003Cp\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E Warning: the information on this page was current at {{ vm.loanRequest.auction.endDate | date }}. \nBorrowers' circumstances may vary over the period of a loan.\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Ch2 ng-if=\"vm.loanRequest.status != 'fulfilled'\"\u003EDun & Bradstreet risk score\u003C\u002Fh2\u003E\u003Cdiv layout=\"row\" layout-padding\u003E\u003Cdiv class=\"sbrs\" flex=\"30\"\u003E\u003Cchartist class=\"ct-chart\" flex chartist-data=\"vm.sbrsChartData\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.sbrsChartOptions\" chartist-events=\"vm.sbrsChartEvents\"\u003E\u003C\u002Fchartist\u003E\u003Cdiv class=\"created-at\"\u003E{{ vm.creditReport.created | date: 'MMMM yyyy' }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv flex layout=\"column\" layout-align=\"start stretch\"\u003E\u003Cp\u003EThe Small Business Risk Score (SBRS) is a statistically-based score using a combination of both consumer\nand commercial information to provide a complete representation of an unincorporated entity. It predicts\nthe likelihood of a credit active unincorporated entity, entering bankruptcy within the next 12 months.\u003C\u002Fp\u003E\u003Cp\u003EFor more information on the Dun & Bradstreet Small Business Risk Score, see \u003Ccontentful-asset title=\"sbrs fact sheet\"\u003Ehere\u003C\u002Fcontentful-asset\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;